import React from "react";

const StatCard = ({ title, value, sub, iconClass }) => (
  <div className="p-3 border rounded-3 h-100">
    <div className="d-flex justify-content-between align-items-center">
      <div>
        <div className="text-muted small">{title}</div>
        <div className="fs-3 fw-semibold">{value}</div>
        {sub ? <div className="small text-secondary">{sub}</div> : null}
      </div>
      {iconClass ? (
        <div className="rounded-circle d-flex align-items-center justify-content-center" style={{ width: 44, height: 44 }}>
          <i className={`bi ${iconClass} fs-5`} />
        </div>
      ) : null}
    </div>
  </div>
);

export default StatCard;
